export default __webpack_public_path__ + "static/media/login-wallpaper.74b0bead.svg";